<template>
  <div class="scrollable" style="height: 17vh">
    <div v-for="f in files" :key="f.url">
      <b-img
          v-if="isImage(f.fileType)"
          v-bind="f.mainProps"
          rounded
          alt="Circle image"
          class="d-inline-block mr-1 mb-1"
          :src="f.url"
          style="float: left"
      />
      <embed v-if="isPDF(f.fileType)"
             style="float: left" :src="f.url" type="application/pdf" :width="f.mainProps.width" :height="f.mainProps.height">
    </div>
  </div>
</template>


<script>
import {
  BNavbarNav, BNavItemDropdown, BDropdownItem, BImg, BAvatar, BBadge, BDropdown, BButton, BFormInput, BPagination, BFormSelect, BCol, BFormGroup, BInputGroupAppend, BInputGroup, BRow, BTable, BAlert, BFormCheckbox, BFormFile, BFormTags
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'

export default {
  components: {
    BCardCode,
    BButton,
    BRow,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormFile,
    BFormTags,
    BImg
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      files: []
    }
  },
  mounted() {
  },
  methods: {
    isImage(fileType) {
      const imageTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        // Füge weitere Bildtypen hinzu, falls gewünscht
      ]

      return imageTypes.includes(fileType);
    },
    isPDF(fileType) {
      const pdfType = 'application/pdf'
      return fileType === pdfType;
    },
    async getFile(fileId) {
      let imgData = this.adjustImageHeight(this.ImageHost(fileId));
      let f = {
        url: imgData.url,
        mainProps: {
          blank: false,
          blankColor: '#777',
          width: imgData.width,
          height: imgData.height,
          class: 'm1',
        },
        fileType: null, // Initialer Wert für den Dateityp
      }
      this.getFileType(f.url)
          .then(fileType => {
            f.fileType = fileType; // Setze den Dateityp für das aktuelle Element in files
          })
          .catch(error => {
            console.log("Fehler beim Ermitteln des Dateityps: " + error);
          });
      this.files.push(f)
    },
    async checkFileType(url) {
      return fetch(url)
          .then(response => response.blob())
          .then(blob => {
            return new Promise(resolve => {
              var reader = new FileReader();
              reader.onloadend = function() {
                var arr = (new Uint8Array(reader.result)).subarray(0, 4);
                var header = "";
                for (var i = 0; i < arr.length; i++) {
                  header += arr[i].toString(16);
                }
                var fileType;

                switch (header) {
                  case "89504e47":
                    fileType = "image/png"; // PNG-Datei
                    break;
                  case "47494638":
                    fileType = "image/gif"; // GIF-Datei
                    break;
                  case "25504446":
                    fileType = "application/pdf"; // PDF-Datei
                    break;
                  case "ffd8ffe0":
                  case "ffd8ffe1":
                  case "ffd8ffe2":
                    fileType = "image/jpeg"; // JPEG-Datei
                    break;
                  case "504b0304":
                    fileType = "application/zip"; // ZIP-Datei, DOCX, XLSX, PPTX
                    break;
                  case "494433":
                  case "fffb":
                  case "fff3":
                    fileType = "audio/mp3"; // MP3-Datei
                    break;
                  case "52494646":
                    fileType = "audio/wav"; // WAV-Datei
                    break;
                  case "00000018667479706D703432":
                  case "00000020667479706D70":
                    fileType = "video/mp4"; // MP4-Datei
                    break;
                  case "7B2276657273696F6E223A":
                    fileType = "application/json"; // JSON-Datei
                    break;
                  default:
                    fileType = "unknown"; // Unbekannter Dateityp
                }

                resolve(fileType);
              };

              reader.readAsArrayBuffer(blob);
            });
          })
          .catch(error => {
            console.log("Fehler beim Abrufen der Datei: " + error);
            return "unknown"; // Falls ein Fehler auftritt, wird "unknown" zurückgegeben
          });
    },
    async getFileType(fileUrl) {
      return await this.checkFileType(fileUrl)
          .then(fileType => {
            console.log("Dateityp: " + fileType);
            return fileType; // Rückgabe des Dateityps
          })
          .catch(error => {
            console.log("Fehler beim Ermitteln des Dateityps: " + error);
          });
    },
    adjustImageHeight(url) {
      var targetHeight = 150  // Zielhöhe

      var img = new Image()
      img.src = url

      const aspectRatio = img.width / img.height   // Seitenverhältnis berechnen
      const newWidth = Math.round(targetHeight * aspectRatio)  // Neue Breite berechnen
      return {
        width: newWidth,
        height: targetHeight,
        url: url,
      }
    },

    ImageHost(id) {
      return this.$http.defaults.baseURL + 'files/get/' + id + "/" + this.$cookies.get("jwt")
    }
  },
}
</script>
<style scoped>
.scrollable {
  white-space: nowrap;
  overflow-x: auto;
}

.scrollable::-webkit-scrollbar {
  width: 10px;
}

.scrollable::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}
</style>